export default __webpack_public_path__ + "static/media/SavedIconPropertyGray.818d2617.svg";